import WithHeaderTemplate from './WithHeaderTemplate'

export default WithHeaderTemplate
